import ua from 'universal-analytics'
var visitor = null;
 //visitor.pageview("/").send()

let init = () => {
    if(!visitor){
        visitor = ua('G-JP9PT20QBG');
    }

    return visitor;
    
}


let pageView = (url) =>{
   return init().pageview(url).send()
}




export {pageView};








